import React from "react";

import ProductPageTemplate from "../../components/global/layout/ProductPageTemplate";
import { messenger } from "../../constants/productPageData";

const MessengerPage = ({ location }) => {
    return (
        <ProductPageTemplate
            page={messenger}
            theme="purple"
            location={location}
        />
    )
}

export default MessengerPage